<template>
  <ion-page>
    <ion-content>
      <div class="hero-container">
        <ion-grid style="padding-bottom: 0">
          <ion-row class="ion-justify-content-center">
            <ion-col size-xl="8" size-sm="11" size-xs="11" style="padding: 0">
              <ion-row
                class="ion-justify-content-center ion-align-items-center"
              >
                <ion-col
                  size-xl="5"
                  size-sm="6"
                  size-xs="12"
                  style="padding: 0"
                >
                  <h1 class="text-h1 os-semibold mb-md" style="color: #000">
                    La tecnología para eventos más avanzada de Panamá
                  </h1>
                  <h2 class="text-h6 mb-lg" style="color: #000">
                    Publica gratis tus eventos sin importar tu boletería de
                    elección.
                  </h2>
                  <ion-row class="mb-lg">
                    <ion-img
                      :src="require('@/assets/images/app-store-badge.svg')"
                      style="width: 175px; cursor: pointer"
                      @click="openStore('appstore')"
                      alt="App Store Badge"
                    />
                    <ion-img
                      :src="require('@/assets/images/play-store-badge.svg')"
                      style="width: 175px; cursor: pointer"
                      @click="openStore('playstore')"
                      alt="Play Store Badge"
                    />
                  </ion-row>
                </ion-col>
                <ion-col
                  size-xl="6"
                  size-sm="6"
                  size-xs="12"
                  style="padding: 0"
                >
                  <ion-img
                    :src="require('@/assets/images/hero.png')"
                    style="width: 60%; margin: 0 auto"
                    alt="OS Hero Phone"
                  />
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="ribbon">Descarga nuestro app para ver todos los eventos</div>

      <div class="text-h4 os-bold text-center mt-lg mb-sm px-md pt-lg">
        Taquilla
      </div>
      <div class="text-subtitle text-center mb-lg px-md">
        Compra tus entradas AQUÍ
      </div>
      <ion-grid class="mb-lg pb-lg">
        <ion-row class="ion-justify-content-center">
          <ion-col size-lg="7" size-xs="12">
            <ion-row>
              <ion-col
                size-lg="3"
                :size-xs="todayEvents.length > 1 ? '6' : '12'"
                size-sm="6"
                size-md="3"
                v-for="event in todayEvents"
                :key="event.id"
              >
                <event-col :event="event" />
              </ion-col>
              <ion-col
                size-lg="3"
                size-xs="6"
                size-sm="6"
                size-md="3"
                v-for="sk in 4"
                :key="sk"
                v-show="globalLoading"
              >
                <ion-skeleton-text
                  :animated="true"
                  style="height: 369px"
                  class="os-rounded-border"
                />
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-grid class="py-lg">
        <ion-row class="ion-justify-content-center">
          <ion-col size-xl="9" size-sm="11">
            <ion-row>
              <ion-col size-xl="6" size-sm="6" size-xs="12">
                <iframe
                  style="aspect-ratio: 16 / 9; width: 100% !important"
                  src="https://www.youtube.com/embed/b7n6Uc6OzSY?si=40CJSi6zS6UuZZUG"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
                <div class="text-h3 os-bold text-center mt-lg mb-lg">
                  Métodos de pago
                </div>
                <div class="text-h5 text-center">
                  La mejor implementación de Yappy de Panamá
                </div>
                <div class="text-h5 os-semibold text-center mb-lg">
                  Dile adiós a los comprobantes de pago
                </div>
                <ion-img
                  :src="require('@/assets/images/payment-methods.png')"
                  style="width: 60%; margin: 0 auto"
                  alt="One Spot Payment Methods"
                />
              </ion-col>
              <ion-col size-xl="6" size-sm="6" size-xs="12">
                <ion-img
                  :src="require('@/assets/images/features.png')"
                  style="margin: 0 auto"
                  alt="One Spot Features"
                />
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid>
        <ion-row class="ion-justify-content-center py-lg">
          <ion-col size-xl="5" size-xs="11">
            <div class="text-h3 os-bold text-center mb-lg">
              Preguntas frecuentes (FAQs)
            </div>
            <div v-for="(faq, i) in faqs" :key="i">
              <div
                class="text-subitle os-semibold faq-header"
                @click="faqShow = i"
              >
                <ion-icon
                  :icon="caretDownOutline"
                  class="mr-md text-os-pink"
                  v-if="faqShow != i"
                />
                <ion-icon
                  :icon="caretUpOutline"
                  class="mr-md text-os-pink"
                  v-else
                />
                {{ i + 1 }}.
                {{ faq.q }}
              </div>
              <div
                class="text-body faq-body"
                v-html="faq.a"
                v-show="faqShow == i"
              />
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer>
      <ion-toolbar class="text-center">
        <div class="text-caption">
          Aquí puedes leer nuestros <br />
          <a
            href="terms-and-conditions/user-register"
            target="_blank"
            class="text-os-pink"
            >Términos y condiciones</a
          >
          y
          <a href="/privacy-policies" target="_blank" class="text-os-pink"
            >Políticas de privacidad</a
          >
        </div>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<script setup lang="ts">
// IONIC / VUE
import {
  IonPage,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonSkeletonText,
  IonFooter,
  IonToolbar,
} from "@ionic/vue";
import { caretDownOutline, caretUpOutline } from "ionicons/icons";
import { computed, ref } from "vue";

// OS COMPONENTS
import EventCol from "@/components/UsersAppGeneral/EventCol.vue";

// STORES
import { storeToRefs } from "pinia";
import { useAppStore } from "@/stores/AppStore";
const appStore = useAppStore();
const { allEvents, globalLoading } = storeToRefs(appStore);

// REFS
const faqShow = ref(0);

// METHODS
const openStore = (store: "appstore" | "playstore") => {
  if (store == "appstore")
    window.open("https://apps.apple.com/pa/app/one-spot/id1604925208");
  if (store == "playstore")
    window.open(
      "https://play.google.com/store/apps/details?id=com.onespotlive.twa"
    );
};

// COMPUTED
const todayEvents = computed(() => {
  const osEv = allEvents.value.filter((ev) => ev.ticketsProvider == "os");
  return osEv;
});

// FAQs
const faqs = [
  {
    q: "¿Qué es One Spot?",
    a: "<b>One Spot</b> es una plataforma integral para la gestión de eventos en Panamá. Permite a los organizadores publicar eventos y a los usuarios descubrir, gestionar y asistir a eventos de manera fácil. Somos la única plataforma que centraliza todos los eventos en Panamá, brindando una experiencia unificada sin importar la boletería que se use o si el evento es gratuito. Con <b>One Spot</b>, obtienes mayor visibilidad y la capacidad de construir comunidades dedicadas a disfrutar nuevas experiencias.",
  },
  {
    q: "¿Cómo puedo registrarme como organizador en One Spot?",
    a: "Registrarse como organizador es fácil y gratuito:<br/><ol><li><b>Descarga</b> la app desde Google Play o App Store.</li><li><b>Crea tu cuenta</b> como organizador.</li><li><b>Publica tus eventos</b> de inmediato.</li></ol>Las cuentas de organizador pasan por un proceso de revisión para asegurar que la información sea real. Se considerarán las cuentas de Instagram y las páginas web para este proceso. Además, los usuarios pueden registrarse para ver todos los eventos disponibles y mantenerse actualizados con las novedades.",
  },
  {
    q: "¿Publicar eventos en One Spot tiene algún costo?",
    a: "<b>Publicar en One Spot es completamente gratis.</b> Regístrate, crea tu evento y empieza a construir tu audiencia sin costo adicional.",
  },
  {
    q: "¿Puedo usar One Spot si mi evento es gratuito?",
    a: "¡Sí! Si tu evento es gratuito, puedes utilizar One Spot para gestionar la cantidad de boletos disponibles. Solo debes configurar el valor del boleto a 0 en la opción de One Spot Tickets, y podrás proporcionar boletos gratuitos de inmediato.",
  },
  {
    q: "¿Puedo utilizar mi propia boletería en lugar de One Spot Tickets?",
    a: "Sí, puedes agregar el enlace a la plataforma de tu elección para la venta de boletos. <b>One Spot</b> centraliza todos los eventos, sin importar dónde se realice la venta de boletos.",
  },
  {
    q: "¿Cómo actualizo mis eventos?",
    a: "Para actualizar tus eventos, accede a tu cuenta en la app de One Spot. Desde allí, podrás editar la información del evento, ajustar los detalles de la venta de boletos y realizar cualquier cambio necesario para mantener tu evento actualizado. <b>¡Descarga One Spot hoy mismo y empieza a gestionar tus eventos de manera eficiente y centralizada! Regístrate como organizador y únete a la revolución en la gestión de eventos.</b> ¡No te pierdas esta oportunidad de transformar tu experiencia de eventos!",
  },
  {
    q: "¿Cómo escanear boletos?",
    a: "Para escanear boletos, solo necesitas tu celular. <b>One Spot</b> ofrece un <b>QR Escáner</b> que registra el ingreso del usuario al evento mediante un código QR. Además, puedes asignar el acceso para taquilla a cualquier usuario registrado en One Spot por medio de correo electrónico.",
  },
  {
    q: "¿Puedo agregar múltiples boletos para un evento?",
    a: "Sí, en <b>One Spot</b> puedes agregar múltiples tipos de boletos para un solo evento. Esto te permite ofrecer diferentes categorías o niveles de acceso, como entradas VIP, general, y descuentos promocionales. Además, puedes controlar la visibilidad de los boletos asignando fechas de inicio y finalización de venta, asegurando que los boletos estén disponibles solo durante el periodo que determines.",
  },
  {
    q: "¿Qué beneficios tiene usar One Spot Tickets?",
    a: "<b>One Spot Tickets</b> ofrece una gama de beneficios:<br/><ul><li><b>Cortesías:</b> Gestión de cortesías y entradas promocionales.</li><li><b>Promotores Públicos y Privados:</b> Herramientas avanzadas para la venta de boletos y el seguimiento de la audiencia.</li><li><b>Venta por Taquilla:</b> Venta de boletos en taquilla el día del evento.</li><li><b>Notificaciones Push Orgánicas:</b> Envío de notificaciones push a tus seguidores sobre actualizaciones y novedades.</li><li><b>Ventas de Espacios Publicitarios:</b> Espacios publicitarios exclusivos con notificaciones push globales, independientemente de la cantidad de seguidores o categoría del evento.</li><li><b>Visualización de Ventas y Google Analytics:</b> Panel para ver todas las ventas y análisis detallado mediante Google Analytics.</li><li><b>Notificaciones Push de Ventas:</b> Notificaciones push de cada venta realizada para mantenerte informado en tiempo real.</li><li><b>Múltiples Boletos:</b> La plataforma permite gestionar y ofrecer múltiples tipos de boletos para un solo evento.</li></ul>",
  },
  {
    q: "¿Qué métodos de pago acepta One Spot?",
    a: "<b>One Spot</b> acepta pagos mediante <b>Visa, Mastercard</b> y la <b>mejor implementación de Yappy en el mercado</b> para garantizar pagos rápidos y seguros. Además, recibirás notificaciones de cada venta realizada.",
  },
  {
    q: "¿Cuáles son los costos y tarifas de servicio?",
    a: "<ul><li><b>Para usuarios:</b> Cobramos un 5% + $1.50 por cada venta de boleto.</li><li><b>Para organizadores:</b> Cobramos un fee del 7% sobre la venta total. Los pagos se realizan en un plazo de 2 días hábiles. Si el evento ocurre durante el fin de semana, los pagos se procesarán el día martes siguiente.</li></ul>",
  },
  {
    q: "¿Cómo recibo mi pago?",
    a: "Recibirás el comprobante de pago, el recibo de ventas y la factura por correo electrónico y a través de la app. Completa los campos referentes al método de pago de tu evento en la plataforma. Los pagos se realizan por ACH.",
  },
  {
    q: "¿Qué distingue a One Spot de otras plataformas?",
    a: "<b>One Spot</b> se distingue por:<ul><li><b>Redirección a Boleterías de Tu Elección:</b> Permite redirigir a tu audiencia a la boletería de tu elección.</li><li><b>Autoadministrable:</b> Total control sobre la gestión de tus eventos. Puedes crear, editar y actualizar tus eventos directamente desde la app.</li><li><b>Innovación Tecnológica:</b> Base para la plataforma con el mayor desarrollo tecnológico en la gestión y asistencia de eventos en Panamá, hecha por panameños.</li><li><b>Características Avanzadas:</b> Incluye notificaciones push orgánicas, gestión de cortesías, venta en taquilla, y venta de espacios publicitarios.</li><li><b>Impulso al Turismo, Cultura y Entretenimiento:</b> Centraliza todos los eventos en Panamá, ofreciendo acceso fácil y rápido a la información sin tener que buscar entre redes sociales o páginas web dispersas.</li></ul>",
  },
  {
    q: "¿Cómo manejo la cancelación de eventos?",
    a: "Para la cancelación de eventos, consulta los términos y condiciones específicos para organizadores en la plataforma de One Spot. Allí encontrarás la información detallada sobre cómo proceder en caso de cancelar un evento.",
  },
];
</script>
